























































import "./assignment-editor.less";
import Vue from "vue";
import { mapState, mapGetters } from "vuex";
import moment from "moment";

export default Vue.extend({
  name: "AssignmentEditor",
  props: {
    objective: {
      default: null,
      type: Object,
    },
    assignment: {
      default: null,
      type: Object,
    },
    showDetail: {
      default: false,
      type: Boolean,
    },
    roleNameResolver: {
      default: null,
      type: Function,
    },
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters("goal", ["canEditCurrentGoal"]),
    ...mapGetters("review", ["canEditCurrentReview"]),
    inputOptions() {
      let assignment = (this as any).assignment;
      return assignment && assignment.inputOptions ? JSON.parse(assignment.inputOptions) : [];
    },
    attachments() {
      var assignment = (this as any).assignment;
      if (assignment && assignment.attachments) {
        return JSON.parse(assignment.attachments);
      } else {
        return [];
      }
    },
    trackingTimeString() {
      let context = this as any;
      return moment(context.assignment.checkpoint.trackingDate).format("hh:mm a");
    },
    trackingTimeClass() {
      let context = this as any;
      let className = "completed";

      if (context.assignment.checkpoint.value === null || context.assignment.checkpoint.value === NaN || context.assignment.checkpoint.value === "") {
        className = moment(context.assignment.checkpoint.trackingDate) < moment() ? "overdue" : "due-in-future";
      }

      return className;
    },
    forGoal() {
      let context = this as any;
      return "goalId" in context.assignment;
    },
  },
  mounted() {
    this.$Notice.config({
      top: 120,
      duration: 3,
    });
  },
  created() {},
  methods: {
    isDisabled(assignment) {
      return assignment.checkpoint.trackerId !== abp.session.userId;
    },
    handleCheckpointChange(cp) {
      cp.changed = true;
    },
    saveCheckpoint(cp, checkChange) {
      if (checkChange === true && cp.changed !== true) {
        return;
      }
      let context = this;
      if (context.forGoal === true) {
        let checkpointDto = {
          id: cp.id,
          objectiveId: this.assignment.objectiveId,
          goalId: this.assignment.goalId,
          value: cp.value,
          trackingDate: cp.trackingDate,
          comments: cp.comments,
        };

        context.$store.dispatch("goal/updateCheckpoint", { data: checkpointDto }).then(() => {
          cp.changed = false;
          context.$Notice.success({
            title: "Check In",
            desc: "Success! ",
          });
        });
      } else {
        let checkpointDto = {
          id: cp.id,
          objectiveId: this.assignment.objectiveId,
          reviewId: this.assignment.reviewId,
          value: cp.value,
          trackingDate: cp.trackingDate,
          comments: cp.comments,
        };

        context.$store.dispatch("review/updateCheckpoint", { data: checkpointDto }).then(() => {
          cp.changed = false;
          context.$Notice.success({
            title: "Check In",
            desc: "Success! ",
          });
        });
      }
    },
    getUnitString(metricMeasurement) {
      if (metricMeasurement === 3) {
        return "%";
      } else if (metricMeasurement === 2) {
        return "$";
      } else {
        return "#";
      }
    },
    getInputLabel(checkpoint) {
      return `${checkpoint.actionName} - ${checkpoint.trackingQuestion}`;
    },
    formatDate(date) {
      return moment(date).format("ddd, MMM D");
    },
    getRoleName(memberId) {
      return this.roleNameResolver ? this.roleNameResolver(memberId) : "";
    },
    handleAttachmentClick(name) {
      let index = parseInt(name.replace("attachment-", ""));
      let attachment = this.attachments[index];
      if (attachment.type == 1) {
        this.$emit("open-video", attachment.type, attachment.link);
      } else if (attachment.type == 2 || attachment.type == 3) {
        window.open(attachment.link, "_blank");
      }
    },
    formatNumber(num) {
      if (num && `${num}`.includes(".")) {
        return `${num}`.toString().replace(/(\d)(?=(\d{3})+\.)/g, function ($1, $2) {
          return $2 + ",";
        });
      } else {
        return `${num}`.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      }
    },
  },
});
